const home = {
  // Hero
  hero_headline_1: 'あなたの',
  hero_headline_family: '家族',
  hero_headline_and: 'と',
  hero_headline_school: '学校',
  hero_headline_2: 'が必要とするリーダーシップ',
  hero_description: '<strong>17年の経験</strong>で実証されたメソッドで、家族関係と教育管理を変革しましょう。真の持続的な成果をもたらすリーダーシップへの道を発見してください。',
  hero_btn_books: '書籍',
  hero_btn_courses: 'コース',
  hero_btn_mentorship: 'Mentoria SÍLEX',
  hero_stat_experience: '年の経験',
  hero_stat_mba: 'USP/Esalq',

  // Books section
  books_title: '書籍と著作:',
  books_title_highlight: '変革の始まり',
  books_subtitle: 'ブラジル全土で数千の家族と教育専門家をすでに変革した書籍とe-book',
  books_format: 'PDF e-Book',
  books_btn_buy: '購入する',
  books_btn_details: '詳細を見る',
  books_guarantee: '7日間保証',
  books_coming_soon: '近日公開',
  books_coming_new: '新タイトル近日公開',
  books_coming_desc: 'さらに素晴らしいコンテンツを準備中です！',
  books_notify_label: 'リリース時に通知する',
  books_details_hover: '詳細を見る',

  // Courses section
  courses_title: 'エリート研修:',
  courses_title_highlight: '完全メソッド',
  courses_subtitle: '17年以上の実践経験で検証されたメソッドによる構造化オンラインコース',
  courses_badge: 'オンラインコース',
  courses_modules: 'モジュール',
  courses_btn_enroll: '今すぐ登録',
  courses_btn_details: '詳細を見る',
  courses_guarantee: '30日間保証',
  courses_coming_new: '新コース近日公開',
  courses_coming_desc: '素晴らしい新研修を準備中です！',
  courses_students: '受講生',
  courses_or: 'または',
  courses_hover_view: 'コースを見る',
  courses_testimonials_title: '受講生の声',

  // SÍLEX Showcase (Vitrine SÍLEX na Home) — i18n: PT provisório (traduzir)
  silex_showcase_eyebrow: 'Método SÍLEX · 48 etapas',
  silex_showcase_title: 'Mentoria',
  silex_showcase_title_highlight: 'SÍLEX',
  silex_showcase_subtitle: 'Para pais e educadores que decidiram parar de disputar atenção — e começar a reconstruir presença, respeito e direção.',
  silex_showcase_body: 'Um método de cinco pilares para substituir o ruído dos confrontos pela clareza do diálogo, instalando uma aliança de respeito mútuo e engajamento prático entre pais, educadores e jovens.',
  silex_showcase_benefits_kicker: 'O que você recebe',
  silex_showcase_benefit_1_title: 'Método completo em 48 etapas',
  silex_showcase_benefit_1_desc: 'As 48 etapas do método, do diagnóstico à consolidação. Presente nos três planos, sem versão reduzida.',
  silex_showcase_benefit_2_title: 'Liberação por conclusão, não por calendário',
  silex_showcase_benefit_2_desc: 'Cada etapa abre quando a anterior é concluída. Você avança no seu ritmo, sem pular fundamento.',
  silex_showcase_benefit_3_title: 'Lives coletivas com o mentor',
  silex_showcase_benefit_3_desc: 'Três no Spark, seis no Lab, quinzenais no Protag. Encontros ao vivo para tirar dúvidas e ver o método aplicado a casos reais.',
  silex_showcase_benefit_4_title: 'Encontros individuais',
  silex_showcase_benefit_4_desc: 'Dois no Lab, de dois a quatro no Protag. Sessões reservadas ao seu cenário específico.',
  silex_showcase_benefit_5_title: 'Suporte no canal do seu plano',
  silex_showcase_benefit_5_desc: 'Pela plataforma no Spark, em grupo no Lab, direto no WhatsApp no Protag.',
  silex_showcase_benefit_6_title: 'Acesso por tempo definido',
  silex_showcase_benefit_6_desc: '90 dias no Spark, 180 no Lab, 365 no Protag. Compra única, sem assinatura e sem renovação automática.',
  silex_showcase_cta_secondary: 'Ver planos e detalhes',
  silex_showcase_plans_kicker: 'Conheça os três planos',
  silex_showcase_plan_spark_name: 'SÍLEX Spark',
  silex_showcase_plan_spark_price: 'R$ 997',
  silex_showcase_plan_spark_duration: '90 dias',
  silex_showcase_plan_spark_tagline: 'Começar com clareza',
  silex_showcase_plan_lab_name: 'SÍLEX Lab',
  silex_showcase_plan_lab_price: 'R$ 2.997',
  silex_showcase_plan_lab_duration: '180 dias',
  silex_showcase_plan_lab_tagline: 'Implementar com consistência',
  silex_showcase_plan_protag_name: 'SÍLEX Protag',
  silex_showcase_plan_protag_price: 'R$ 8.997',
  silex_showcase_plan_protag_duration: '365 dias',
  silex_showcase_plan_protag_tagline: 'O caminho principal',
  silex_showcase_plan_protag_highlight: 'Recomendado',
  silex_showcase_plan_duration_label: 'de acesso',
  silex_showcase_plan_card_cta: 'Ver detalhes',
  silex_showcase_plans_note: 'Opções de parcelamento disponíveis no checkout.',
  silex_showcase_guarantee_title: 'Garantia SÍLEX de Clareza e Aplicação',
  silex_showcase_guarantee_text: 'Sete dias para verificar se a estrutura faz sentido para o seu contexto. Se não fizer, o cancelamento é seu direito, sem burocracia.',
  silex_showcase_cta_primary: 'Conhecer a Mentoria SÍLEX',

  // Action Center
  action_title: '次のステップ：',
  action_title_highlight: 'アクションセンター',
  action_subtitle: '変革への理想的な道を選択してください',
  action_quick_title: 'クイックスタート',
  action_quick_desc: '今日からe-bookで管理を変革しましょう',
  action_quick_btn: '書籍を見る',
  action_deep_title: '完全研修',
  action_deep_desc: '構造化されたコースですべての戦略をマスターしましょう',
  action_deep_btn: 'コースを見る',
  action_deep_badge: '最人気',
  action_elite_title: 'エリートアクセス',
  action_elite_desc: '卓越した結果のための専用メンタリング',
  action_faq_title: 'よくある質問',
  action_faq_q1: 'コースへのアクセスはどのように機能しますか？',
  action_faq_a1: '購入後、完全なコンテンツへの即時かつ生涯アクセスが付与され、自分のペースで学習できます。',
  action_faq_q2: 'e-bookは物理的ですか、デジタルですか？',
  action_faq_a2: 'すべての書籍はデジタルPDF形式で、購入後すぐにアクセスできます。',
  action_faq_q3: 'コースとメンタリングの違いは何ですか？',
  action_faq_a3: 'コースは自己学習のための構造化コンテンツです。メンタリングはパーソナライズされた専用の個別指導です。',
  action_faq_q4: '満足保証はありますか？',
  action_faq_a4: 'はい！e-bookに7日間、コースに30日間の保証を提供します。満足されない場合は投資を返金します。',
  action_faq_q5: 'メンタリングの申請プロセスはどのように機能しますか？',
  action_faq_a5: 'フォームに記入後、チームがプロフィールを審査し、24時間以内に会話のスケジュールを調整します。',
  action_cta_title: 'リーダーシップを変革する準備ができましたか？',
  action_cta_desc: '私たちのメソッドですでに人生を変革した専門家に参加しましょう',
  action_cta_btn_explore: '製品を探索する',

  // Social Proof
  social_title: 'Instagramの独占コンテンツ',
  social_subtitle: '教育管理と家族関係に関するコンテンツをフォローしてください',
  social_follow: '今すぐフォロー',

  // Footer
  footer_partner_label: 'Projeto parceiro',
  footer_partner_name: 'Protocolo & Conexão',
  footer_partner_desc: 'Palestras e formações para escolas, famílias e empresas.',
  footer_partner_cta: 'Conhecer o projeto',
  footer_brand_desc: '17年以上にわたる実証済みのメソッドで教育リーダーと家族を変革。',
  footer_products_title: '製品',
  footer_products_books: '書籍とe-book',
  footer_products_courses: 'オンラインコース',
  footer_products_talks: '企業向け講演',
  footer_products_webinars: 'ライブウェビナー',
  footer_company_title: '会社',
  footer_company_about: '会社概要',
  footer_company_contact: 'お問い合わせ',
  footer_support_title: 'サポート',
  footer_support_help: 'ヘルプセンター',
  footer_support_privacy: 'プライバシーポリシー',
  footer_support_terms: '利用規約',
  footer_support_refund: '返金について問い合わせる',
  footer_copyright: '© {{ano}} SB Family & Mastery. 全著作権所有。',
  footer_secure: '安全なサイト',
  footer_payment: '保護された支払い',

  // FAQ Page
  faq_badge: 'ヘルプセンター',
  faq_title: 'どのようにお手伝いできますか？',
  faq_subtitle: 'プラットフォーム、コース、支払い、証明書に関するよくある質問の回答をご覧ください。',
  faq_cat_geral: '一般',
  faq_cat_acesso: 'アクセスとアカウント',
  faq_cat_cursos: 'コース',
  faq_cat_pagamento: '支払い',
  faq_cat_certificado: '証明書',
  faq_cat_mentoria: 'メンタリング',
  faq_not_found_title: 'お探しのものが見つかりませんでしたか？',
  faq_not_found_desc: 'サポートチームは月曜日から金曜日の午前8時から午後6時まで対応しております。',
  faq_not_found_btn: 'サポートに連絡',

  // Cursos Page
  cursos_badge: 'エリートプログラム',
  cursos_title: 'コース',
  cursos_title_highlight: 'カタログ',
  cursos_subtitle: '教育管理と家族関係を変革する実証済みの方法論。',
  cursos_stat_courses: 'コース数',
  cursos_stat_rating: '平均評価 4.8',
  cursos_stat_guarantee: '30日間保証',
  cursos_search_placeholder: 'コースを検索...',
  cursos_filter_all_areas: 'すべてのエリア',
  cursos_filter_all_levels: 'すべてのレベル',
  cursos_filter_all_durations: '期間を問わず',
  cursos_filter_clear: 'クリア',
  cursos_results_found_one: 'コースが見つかりました',
  cursos_results_found_many: 'コースが見つかりました',
  cursos_results_none: 'コースが見つかりません',
  cursos_no_results_title: '結果が見つかりません',
  cursos_no_results_desc: 'フィルターを調整するか、別のキーワードで検索してみてください。',
  cursos_no_results_btn: 'フィルターをクリア',
  cursos_badge_online: 'オンラインコース',
  cursos_modules_label: 'モジュール',
  cursos_enroll_btn: '今すぐ登録',
  cursos_details_btn: '詳細を見る',
  cursos_view_btn: 'コースを見る',
  cursos_cta_title: '早く結果を出したいですか？',
  cursos_cta_desc: 'プレミアムメンタリングは、個別指導であなたの学校や家族を変革する最短の方法です。',
  cursos_students_label: '受講生',
  cursos_or_label: 'または',

  // Sobre Page
  sobre_badge: '会社概要',
  sobre_title: '変革するリーダーを育てる17年間',
  sobre_subtitle: 'SB Family & Masteryは、真のリーダーシップは家庭から始まり、機関へと広がるという確信から生まれました。私たちは明確な使命を持つエグゼクティブ教育プラットフォームです：応用可能な知識を通じて家族と学校を変革すること。',
  sobre_mission_label: '私たちの使命',
  sobre_vision_label: '私たちのビジョン',
  sobre_purpose_label: '私たちの目的',
  sobre_mission_text: '人々と機関の生活に実際で測定可能な変革をもたらす実践的なツールと実証済みの方法論で教育・家族リーダーを強化すること。',
  sobre_vision_text: 'ブラジルにおける家族・学校管理のエグゼクティブ教育の主要な参照点となり、永続的な遺産を築くリーダーの世代を育成すること。',
  sobre_purpose_text: '強化されたすべての家族と、よく管理されたすべての学校が世代を超えてポジティブな影響の波を生み出すと信じています。だから私たちはこれをしています。',
  sobre_values_title: '私たちの価値観',
  sobre_values_desc: 'チームのすべての決定、すべてのコンテンツ、すべての交流を導く柱。',
  sobre_team_badge: '背後にいる人々',
  sobre_team_title: '創立チーム',
  sobre_team_desc: '教育、心理学、テクノロジーで豊富な経験を持つ専門家たち。',
  sobre_timeline_title: '私たちの歩み',
  sobre_timeline_desc: '17年の歴史、学び、そして影響。',
  sobre_cta_title: '変革の一部になりましょう',
  sobre_cta_desc: 'SB Family & Masteryと共に成長することを選んだ家族と教育者に参加しましょう。',
  sobre_cta_contact: 'お問い合わせ',

  // Contato Page
  contato_badge: 'お問い合わせ',
  contato_title: 'お手伝いするためにここにいます',
  contato_subtitle: 'サポートチームは24時間以内に返答いたします。最も便利なチャンネルをお選びください。',
  contato_form_title: 'メッセージを送る',
  contato_form_desc: 'フォームに記入してください。24時間以内にご返答いたします。',
  contato_name_label: 'フルネーム *',
  contato_email_label: 'メールアドレス *',
  contato_subject_label: '件名',
  contato_message_label: 'メッセージ *',
  contato_send_btn: 'メッセージを送信',
  contato_sending: '送信中...',
  contato_success_title: 'メッセージが送信されました！',
  contato_success_desc: 'チームが24時間以内にご返答いたします。',
  contato_success_new: '新しいメッセージを送る',
  contato_error: '送信エラーです。再試行するか別のチャンネルを使用してください。',
  contato_faq_title: 'クイック質問',
  contato_faq_desc: 'あなたの質問はFAQですでに回答されているかもしれません：',
  contato_faq_all: 'ヘルプセンター全体を見る',
  contato_hours_title: '営業時間',
  contato_online: 'サポートオンライン中',
  contato_hours_weekday: '月曜日 – 金曜日',
  contato_hours_weekday_val: '午前8時〜午後6時',
  contato_hours_saturday: '土曜日',
  contato_hours_saturday_val: '午前9時〜午後1時',
  contato_hours_sunday: '日曜日・祝日',
  contato_hours_sunday_val: '休業',
};

export default home;
